import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";

const Logout = () => {
  const { setToken } = useAuth();

  useEffect(() => {
    setToken(null);
  }, [setToken]);

  // Redirection vers la page d'accueil et changement de l'historique de navigation
  return <Navigate to="/login" replace={true} />;
};

export default Logout;
